import React, { useState } from "react";
import { Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Toggle } from "../../superAdminReusable/reusableSuperAdminButton/Toggle";
import SuperAdminDeleteEvent from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteEvent";
import moment from "moment";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const ViewEventDetailsOffline = (props) => {
  const [showLog, setShowLog] = useState(false);
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [selectedTab, setSelectedTab] = useState("1");
  const [checkedBox, setCheckedBox] = useState(false);

  const handleChangeSwitch = (e) =>
    setCheckedBox({ checkedBox: !checkedBox.checkedBox });
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };

  return (
    <>
      <Modal
        show={props.showView}
        onHide={props.handleCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Event Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="d-flex">
            <div className="enIMG75">
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Image
                    src={
                      props.restaurantDetailFromOfferId &&
                      props.restaurantDetailFromOfferId.restaurant_id &&
                      props.restaurantDetailFromOfferId.restaurant_id.logo_url
                    }
                    alt={
                      props.restaurantDetailFromOfferId?.restaurant_id
                        ?.restaurant_name
                    }
                    title={
                      props.restaurantDetailFromOfferId?.restaurant_id
                        ?.restaurant_name
                    }
                    fluid
                    className="w-100 h-100"
                  />
                </SRLWrapper>
              </SimpleReactLightbox>
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">
                  {
                    props?.restaurantDetailFromOfferId?.restaurant_id
                      ?.restaurant_name
                  }
                </div>
                <div className="f14-400">
                  {
                    props?.restaurantDetailFromOfferId?.restaurant_id
                      ?.restaurant_address
                  }
                </div>
              </Col>
            </div>
          </div>
          <hr />
          <div className="enTabs d-flex flex-wrap align-items-center mb-4 mb-2">
            <Button
              variant="link"
              onClick={(e) => handleTab("1")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "1" ? "active" : ""
              }`}
            >
              General Information
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab("2")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "2" ? "active" : ""
              }`}
            >
              RSVP
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab("3")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "3" ? "active" : ""
              }`}
            >
              Ticket Booking
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab("4")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "4" ? "active" : ""
              }`}
            >
              Seating
            </Button>
          </div>
          <div className="enGrayBorderBox">
            <Row className="px-4">
              <Col lg={7} md={12}>
                <Row>
                  <Col lg={8} md={6} className="py-3">
                    <div className="f12-500 pb-3">My Event</div>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center w-25">
                        <SimpleReactLightbox>
                          <SRLWrapper options={options}>
                            <Image
                              src={
                                props?.restaurantDetailFromOfferId &&
                                props?.restaurantDetailFromOfferId.photos &&
                                props?.restaurantDetailFromOfferId.photos[0]
                              }
                              alt="View"
                              title="View"
                              fluid
                              className="w-100 h-100 rounded"
                            />
                          </SRLWrapper>
                        </SimpleReactLightbox>
                        <div className="enPendingLBL mt-2">Offline</div>
                      </div>
                      <div className="pl-3">
                        <div className="f14-500">
                          {props?.restaurantDetailFromOfferId?.name}
                        </div>
                        <div className="f12-400">
                          {props?.restaurantDetailFromOfferId?.description}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} md={6} className="py-3">
                    <div className="f12-500 pb-3">Timing</div>
                    <div className="f12-500">
                      {moment(
                        props?.restaurantDetailFromOfferId?.start_date
                      ).format("hh:mm A")}
                    </div>
                    <div className="f12-500 pl-4 py-1">to</div>
                    <div className="f12-500">
                      {moment(
                        props?.restaurantDetailFromOfferId?.end_date
                      ).format("hh:mm A")}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={5} md={12}>
                <Row>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Start Date</div>
                    <div className="f12-500">
                      {moment(
                        props?.restaurantDetailFromOfferId?.start_date
                      ).format("Do MMM YY")}
                    </div>
                  </Col>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">End Date</div>
                    <div className="f12-500 text-red">
                      {moment(
                        props?.restaurantDetailFromOfferId?.end_date
                      ).format("Do MMM YY")}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="d-flex align-items-center">
                  <div className="f12-400 mr-2">
                    {props?.restaurantDetailFromOfferId?.active
                      ? "Active"
                      : "Inactive"}
                  </div>
                  <Toggle
                    checked={props?.restaurantDetailFromOfferId?.active}
                    toggleFunction={
                      () => {}
                      // toggleFunction
                    }
                  />
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Primary</div>
                <div className="d-flex align-items-center">
                  <div
                    className={`${
                      props?.restaurantDetailFromOfferId?.mark_as_primary
                        ? "f12-400 mr-2"
                        : "f12-500 mr-2"
                    }`}
                  >
                    No
                  </div>
                  <Toggle
                    checked={
                      props?.restaurantDetailFromOfferId?.mark_as_primary
                    }
                    toggleFunction={
                      () => {}
                      // toggleFunction
                    }
                  />
                  <div
                    className={`${
                      props?.restaurantDetailFromOfferId?.mark_as_primary
                        ? "f12-500 ml-2"
                        : "f12-400 ml-2"
                    }`}
                  >
                    Yes
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Venue</div>
                <div className="f14-400">
                  {props?.restaurantDetailFromOfferId?.venue_address}
                </div>
              </Col>
              {/* <Col lg={3} md={6} className="py-3">
                    <div className="f12-500 pb-3">Coupon Code</div>
                    <div className="f14-400">
                      {props?.restaurantDetailFromOfferId?.eventPassword}
                    </div>
                  </Col> */}
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="d-flex align-items-center">
                  <NavLink
                    to="/superadminrestaurantevents/edit-offline-event"
                    className="enIconBtn mr-3"
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </NavLink>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={props?.showOpenDeleteModel}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/Delete.svg")}
                      alt="Delete"
                      title="Delete"
                      fluid
                    />
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          {selectedTab === "1" && (
            <React.Fragment>
              <div className="pt-4 f12-400 opacity5">Event Name</div>
              <div className="d-flex align-items-center pt-2">
                <div className="f16-500">
                  {props?.restaurantDetailFromOfferId?.name}
                </div>
                <div className="enPendingLBL ml-2">Offline</div>
              </div>
              <div className="pt-4 f12-400 opacity5">Description</div>
              <div className="pt-2 f12-400">
                {props?.restaurantDetailFromOfferId?.description}
              </div>
              <hr />
              <div className="pb-2 f12-400 opacity5">Kids Allowed</div>
              <div className="d-flex align-items-center">
                <div
                  className={`${
                    props?.restaurantDetailFromOfferId?.isKidsAllowed
                      ? "f12-400 mr-2"
                      : "f12-500 mr-2"
                  }`}
                >
                  No
                </div>
                <Toggle
                  checked={props?.restaurantDetailFromOfferId?.isKidsAllowed}
                  toggleFunction={
                    () => {}
                    // toggleFunction
                  }
                />
                <div
                  className={`${
                    props?.restaurantDetailFromOfferId?.isKidsAllowed
                      ? "f12-500 mr-2"
                      : "f12-400 mr-2"
                  }`}
                >
                  Yes
                </div>
              </div>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {" "}
                      {moment(
                        props?.restaurantDetailFromOfferId?.start_date
                      ).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {moment(
                        props?.restaurantDetailFromOfferId?.start_date
                      ).format("hh:mm A")}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">End Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {moment(
                        props?.restaurantDetailFromOfferId?.end_date
                      ).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">End Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {moment(
                        props?.restaurantDetailFromOfferId?.end_date
                      ).format("hh:mm A")}
                    </div>
                  </div>
                </Col>
                {/* <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">Coupon Code</div>
                  <div className="f16-700">ASCFGFML12</div>
                </Col> */}
              </Row>
              <hr />
              <div className="pt-4 f12-400 opacity5">
                Venue /Address / Location
              </div>
              <div className="pt-2 pb-4 f12-400">
                {props?.restaurantDetailFromOfferId?.venue_address}
              </div>
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">Event Photos</div>
                <div className="enIMG105">
                  {props?.restaurantDetailFromOfferId?.photo_thumbnails &&
                    props?.restaurantDetailFromOfferId?.photo_thumbnails.map(
                      (item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <SimpleReactLightbox>
                              <SRLWrapper options={options}>
                                <Image
                                  src={item}
                                  alt="Offer Picture"
                                  title="Offer Picture"
                                  fluid
                                  className="w-100 h-100 img-fluid img-thumbnail"
                                />
                              </SRLWrapper>
                            </SimpleReactLightbox>
                          </React.Fragment>
                        );
                      }
                    )}
                </div>
                {/* <div className="pt-2 f12-400">
                  (You can upload only 1 pic per offer 700 x 420 pixels)
                </div> */}
              </div>
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">Event Video</div>
                <div className="enIMG105">
                  {props?.restaurantDetailFromOfferId?.videos === "" ? (
                    <p className="text-red f14-500">Video Not Available</p>
                  ) : props?.restaurantDetailFromOfferId?.videos !==
                      undefined &&
                    props?.restaurantDetailFromOfferId?.videos !== null ? (
                    <div className="">
                      <video
                        width="100%"
                        height="100%"
                        controls
                        src={props?.restaurantDetailFromOfferId?.videos}
                        type="video/mp4"
                      />
                    </div>
                  ) : null}
                </div>
                {/* <div className="pt-2 f12-400">
                  (You can upload only 1 pic per offer 700 x 420 pixels)
                </div> */}
              </div>
              <div className="pb-4">
                <div className="f12-400 opacity5">Terms and Conditions</div>
                <div className="pt-2 f12-400">
                  {props?.restaurantDetailFromOfferId?.terms_and_condition}
                </div>
              </div>
            </React.Fragment>
          )}
          {selectedTab === "2" && (
            <React.Fragment>
              <Row>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 opacity5 pb-3">Auto Accept</div>
                  <div className="d-flex align-items-center">
                    {/* <div
                    className={`${
                      props?.restaurantDetailFromOfferId?.mark_as_primary
                        ? "f12-400 mr-2"
                        : "f12-500 mr-2"
                    }`}
                  >
                    No
                  </div>
                  <Toggle
                    checked={
                      props?.restaurantDetailFromOfferId?.mark_as_primary
                    }
                    toggleFunction={
                      () => {}
                      // toggleFunction
                    }
                  />
                  <div
                    className={`${
                      props?.restaurantDetailFromOfferId?.mark_as_primary
                        ? "f12-500 ml-2"
                        : "f12-400 ml-2"
                    }`}
                  >
                    Yes
                  </div> */}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 opacity5 pb-3">
                    Maximum Number of Guests
                  </div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.maxGuest_RSVP}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 opacity5 pb-3">Buffer %</div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.buffer_RSVP_guest}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTab === "3" && (
            <React.Fragment>
              <hr />
              <div className="enTicketBox d-flex flex-wrap">
                <div className="enbox">
                  <div className="f12-500 opacity5 pb-3">Ticket Name</div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.ticketName}
                  </div>
                </div>
                <div className="enbox">
                  <div className="f12-500 opacity5 pb-3">Ticket Type</div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.event_type}
                  </div>
                </div>
                <div className="enbox">
                  <div className="f12-500 opacity5 pb-3">Adult Price</div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.adult_price}
                  </div>
                </div>
                <div className="enbox">
                  <div className="f12-500 opacity5 pb-3">Child Price</div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.child_price}
                  </div>
                </div>
                <div className="enbox">
                  <div className="f12-500 opacity5 pb-3">Total Quantity</div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.total_quantity_TB}
                  </div>
                </div>
              </div>
              <div className="enTicketBox d-flex flex-wrap">
                <div className="enbox2">
                  <div className="f12-500 opacity5 pb-3">
                    Minimum people per booking
                  </div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.min_people_per_booking}
                  </div>
                </div>
                <div className="enbox2">
                  <div className="f12-500 opacity5 pb-3">
                    Maximum people per booking
                  </div>
                  <div className="f16-700">
                    {props?.restaurantDetailFromOfferId?.max_people_per_booking}
                  </div>
                </div>
              </div>
              <div className="f12-400 opacity5 pb-3">Ticket Description</div>
              <div className="f12-400 pb-4">
                {props?.restaurantDetailFromOfferId?.terms_and_condition}
              </div>
            </React.Fragment>
          )}
          {selectedTab === "4" && (
            <React.Fragment>
              <hr />
              <Row>
                <Col lg={12}>
                  {props?.restaurantDetailFromOfferId?.table_setup?.floors.map(
                    (item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div className="enTicketBox d-flex flex-wrap">
                            <div className="enbox2">
                              <div className="f12-500 opacity5 pb-3">
                                Floor Number / Seating Area
                              </div>
                              <div className="f16-700">{item.floor_number}</div>
                            </div>
                            <div className="enbox2">
                              <div className="f12-500 opacity5 pb-3">
                                Section Name/Number
                              </div>
                              <div className="f16-700">{item.area}</div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    }
                  )}
                </Col>
              </Row>
            </React.Fragment>
          )}
          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{" "}
              <Image
                src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Phone Number</div>
                  <div className="f14-400">
                    {/* {props?.restaurantDetailFromOfferId?.restaurant_id
                      ?.contact_detail &&
                    props?.restaurantDetailFromOfferId?.restaurant_id?.contact_detail
                      .length <= 0
                      ? "-"
                      : props?.restaurantDetailFromOfferId?.restaurant_id?.contact_detail.map(
                          (item, index) => {
                            if (index === 0) {
                              return item.country_code + item.mobile_no;
                            } else if (item) {
                              return ", " + item.country_code + item.mobile_no;
                            }
                          }
                        )} */}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Event ID</div>
                  <div className="f14-400">
                    #{props?.restaurantDetailFromOfferId?.event_id}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Start Date / Time</div>
                  <div className="f14-400">
                    {moment(
                      props?.restaurantDetailFromOfferId?.start_date
                    ).format("Do MMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {moment(
                      props?.restaurantDetailFromOfferId?.start_date
                    ).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">End Date / Time</div>
                  <div className="f14-400">
                    {moment(
                      props?.restaurantDetailFromOfferId?.end_date
                    ).format("Do MMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {moment(
                      props?.restaurantDetailFromOfferId?.end_date
                    ).format("hh:mm A")}
                  </div>
                </Col>
                <Col md={12}>
                  <hr />
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">
                    {moment(
                      props?.restaurantDetailFromOfferId?.updatedAt
                    ).format("Do MMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {moment(
                      props?.restaurantDetailFromOfferId?.updatedAt
                    ).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">
                    {" "}
                    {moment(
                      props?.restaurantDetailFromOfferId?.createdAt
                    ).format("Do MMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {" "}
                    {moment(
                      props?.restaurantDetailFromOfferId?.createdAt
                    ).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Pont of Entry</div>
                  <div className="f14-400">Menually Added</div>
                </Col>
                {/* <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Maximum Usage Limit</div>
                  <div className="f14-400">100</div>
                </Col> */}
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <tr>
                  <th className="">
                    <div className="f12-500">Date</div>
                  </th>
                  <th>
                    <div className="f12-500">Operation</div>
                  </th>
                  <th></th>
                </tr>
                {props?.restaurantDetailFromOfferId?.auditLogs &&
                  props?.restaurantDetailFromOfferId?.auditLogs.map(
                    (data, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>
                              <div className="f12-500">
                                {moment(data.timestamp).format("Do MMMM, YYYY")}
                              </div>
                              <div className="f12-500">
                                {moment(data.timestamp).format("hh:mm A")}
                              </div>
                            </td>
                            <td>
                              <div className="f12-500">{data.message}</div>
                            </td>
                            <td>
                              <div className="f12-500">{data.initiator}</div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )}
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <React.Fragment>
        <Modal
          show={props?.showDeleteEvent}
          onHide={props?.closeDeleteModal}
          centered
        >
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to Delete the Event ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={props?.closeDeleteModal}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={props?.deleteEventOnline}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </>
  );
};
export default ViewEventDetailsOffline;
